import type React from 'react';

import { useTheme } from '@/app/ThemeContext';
import type { RiskWithVulnerability } from '@/hooks/useRisks';
import { getTicketingIntegration } from '@/hooks/useTicketingIntegrations';
import { getTicketDisplayId } from '@/utils/ticketDisplay.util';
import { isValidExternalURL } from '@/utils/url.util';

export interface ITSMTicketCellProps {
  risk: RiskWithVulnerability;
}

export const ITSMTicketCell: React.FC<ITSMTicketCellProps> = ({ risk }) => {
  const { ticket } = risk;
  const { currentTheme } = useTheme();

  if (!ticket) {
    return <span className="text-secondary text-xs">--</span>;
  }

  const integration = getTicketingIntegration(ticket.provider);
  const hasValidLink = isValidExternalURL(ticket.link);
  const displayId = getTicketDisplayId({
    id: ticket.ticketId,
    link: ticket.link,
  });

  return (
    <div className="flex min-w-0 items-center gap-1.5">
      {integration?.logo && (
        <img
          src={`/icons/${currentTheme}/${integration.logo}`}
          alt={integration.name ?? ticket.provider}
          className="size-4 shrink-0"
        />
      )}
      {hasValidLink ? (
        <a
          href={ticket.link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-brand truncate text-xs hover:underline"
          title={`${displayId} (${ticket.status})`}
          onClick={e => e.stopPropagation()}
        >
          {displayId}
        </a>
      ) : (
        <span className="truncate text-xs" title={displayId}>
          {displayId}
        </span>
      )}
    </div>
  );
};
